import firebase from 'firebase/compat/app';

import env from 'env/.public-env.json';

export const submitContactUsForm = async ({
  type,
  subject,
  message,
  attachments,
  metadata,
}: {
  type: string;
  subject: string;
  message: string;
  attachments: File[];
  metadata: string;
}): Promise<boolean> => {
  const user = firebase.auth().currentUser;
  if (!user) {
    return false;
  }

  const token = await user.getIdToken();
  const form = new FormData();
  form.append('type', type);
  form.append('subject', subject);
  form.append('message', message);
  form.append('metadata', metadata);
  for (const file of attachments) {
    form.append('attachments', file, file.name);
  }

  const response = await fetch(
    `${env.DASH_API_URL}/api/client/support-ticket`,
    {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    },
  );

  return response.ok;
};
